import { SET_SIDEBAR_STATE } from './action-types'

export function setSidebarState(open) {
  return {
    type: SET_SIDEBAR_STATE,
    open,
  }
}
